module.exports = __webpack_public_path__ + "img/icon-RequestControl.375e0ad4.png";